import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { BadgeCheck, X } from 'lucide-react';
import type { SalesNotification } from '../../types/salesPage';
interface SalesNotificationsProps {
  items: SalesNotification[];
  product: string;
}
const FIRST_DELAY_MS = 6000;
const VISIBLE_MS = 6000;
const GAP_MS = 9000;
export function SalesNotifications({
  items,
  product
}: SalesNotificationsProps) {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let hideTimer = 0;
    const showTimer = window.setTimeout(() => {
      setVisible(true);
      hideTimer = window.setTimeout(() => {
        setVisible(false);
        setIndex(current => (current + 1) % items.length);
      }, VISIBLE_MS);
    }, index === 0 && !visible ? FIRST_DELAY_MS : GAP_MS);
    return () => {
      window.clearTimeout(showTimer);
      window.clearTimeout(hideTimer);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [index, dismissed, items.length]);
  const item = items[index];
  return <AnimatePresence data-id="element-260" data-mp="1zenaz1ahifxq">
      {visible && !dismissed && item && <motion.div initial={{
      opacity: 0,
      x: -28,
      y: 10
    }} animate={{
      opacity: 1,
      x: 0,
      y: 0
    }} exit={{
      opacity: 0,
      x: -28,
      y: 10
    }} transition={{
      duration: 0.4,
      ease: 'easeOut'
    }} role="status" aria-live="polite" className="fixed bottom-24 left-3 z-40 w-[min(320px,calc(100vw-1.5rem))] rounded-sm border border-white/10 bg-carbon/95 p-3.5 shadow-[0_18px_40px_rgba(0,0,0,0.6)] backdrop-blur-sm sm:bottom-6 sm:left-5" data-id="element-261" data-mp="1zd2cx1oyoev4">
          <div className="flex items-start gap-3" data-id="element-262" data-mp="2d8o51hqhrerr">
            <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-gold/35 bg-gold/[0.08] font-mono text-[11px] text-gold-soft" data-id="element-263" data-mp="16rkesfta6han">
              {item.initials}
            </span>

            <div className="min-w-0 flex-1" data-id="element-264" data-mp="3pxv7xbfnthvj">
              <p className="font-serif text-[14px] leading-snug text-ivory" data-id="element-265" data-mp="3tyyq44l6jpzx">
                <span className="font-semibold" data-id="element-266" data-mp="3twuipco2o8uw">{item.name}</span>{' '}
                <span className="text-ash" data-id="element-267" data-mp="3fye6553j3o4u">de {item.city}</span>
              </p>
              <p className="mt-0.5 flex items-center gap-1.5 text-[12.5px] font-light text-smoke" data-id="element-268" data-mp="3kx7i2t36372w">
                <BadgeCheck aria-hidden="true" className="h-3.5 w-3.5 shrink-0 text-gold" data-id="element-269" data-mp="368bcd2ol265g" />
                Acaba de obtener {product}
              </p>
              <p className="mt-1 font-mono text-[8.5px] uppercase tracking-[0.12em] text-ash/60" data-id="element-270" data-mp="3b1xi0awbx9rr">
                {item.timeAgo} · Compra verificada
              </p>
            </div>

            <button type="button" onClick={() => setDismissed(true)} aria-label="Cerrar notificaciones de compra" className="-mr-1 -mt-1 flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-ash/60 transition-colors duration-200 hover:text-ivory focus:outline-none focus-visible:ring-2 focus-visible:ring-gold-soft" data-id="element-271" data-mp="325og8pkvpz2g">
              <X aria-hidden="true" className="h-3.5 w-3.5" data-id="element-272" data-mp="24oasjcr3hq3l" />
            </button>
          </div>

          <motion.span aria-hidden="true" initial={{
        width: '100%'
      }} animate={{
        width: '0%'
      }} transition={{
        duration: VISIBLE_MS / 1000,
        ease: 'linear'
      }} className="mt-3 block h-px bg-gold/60" data-id="element-273" data-mp="2ijwbp3andfo3" />
        </motion.div>}
    </AnimatePresence>;
}